// When the flag is on, the project root is the Overview, and viewers can read MLAP.
// When it is off, the root is Details, and MLAP is for editors only.
const MLAP_OVERVIEW_FEATURE = 'mlap_overview'

export function overviewEnabled(globalStore) {
  return Boolean(globalStore?.hasFeature?.(MLAP_OVERVIEW_FEATURE))
}
